import type { ApiFormQuestionOption } from 'src/core/models/api/shared/ApiFormQuestion';

export interface ChoiceGroup {
	label: string;
	options: ApiFormQuestionOption[];
}

/**
 * The options of a choice question, split by the day they belong to (#404).
 */
export function choiceGroups(options: ApiFormQuestionOption[]): ChoiceGroup[] {
	const groups: ChoiceGroup[] = [];
	const byRef = new Map<string, ChoiceGroup>();

	options.forEach((option) => {
		const ref = option.day_ref ?? '';

		// An option without a day (a typed-in one, or one from before days were stored) belongs to no group and
		// keeps the list flat.
		if (ref === '') {
			const flat = byRef.get('');
			if (flat) {
				flat.options.push(option);
				return;
			}
			const group = { label: '', options: [option] };
			byRef.set('', group);
			groups.push(group);
			return;
		}

		const existing = byRef.get(ref);
		if (existing) {
			existing.options.push(option);
			return;
		}

		const group = { label: option.day_label ?? '', options: [option] };
		byRef.set(ref, group);
		groups.push(group);
	});

	// One group is no grouping: a question about a single day needs no heading repeating what the question
	// already says.
	if (groups.length <= 1) {
		return groups.map((group) => ({ ...group, label: '' }));
	}

	return groups;
}
